module.exports = __webpack_public_path__ + "images/emoji/musical_keyboard.03767c8e4cc1a89432d0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/musical_keyboard.png
// module id = R8lo
// module chunks = 2